import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Twitter } from 'lucide-react';
import { profileData } from '../mock';
import Logo from './Logo';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const startYear = 2022;

  const quickLinks = [
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Experience', href: '#experience' },
    { name: 'Case Studies', href: '#case-studies' }
  ];

  const resources = [
    { name: 'Publications', href: '#publications' },
    { name: 'Insights', href: '#blog' },
    { name: 'Latest News', href: '#news' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-brand">
            <Logo className="footer-logo-component" />
            <p className="footer-tagline">Led by {profileData.name}</p>
            <p className="footer-description">
              {profileData.yearsExperience}+ years of strategic counsel in government relations, policy analysis, and international lobbying across Europe and Asia.
            </p>
            <div className="footer-social">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <Linkedin size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-list">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a href={link.href}>{link.name}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div className="footer-links">
            <h4 className="footer-heading">Resources</h4>
            <ul className="footer-list">
              {resources.map((link) => (
                <li key={link.name}>
                  <a href={link.href}>{link.name}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h4 className="footer-heading">Contact</h4>
            <div className="footer-contact-list">
              <div className="footer-contact-item">
                <Mail size={16} />
                <a href={`mailto:${profileData.email}`}>{profileData.email}</a>
              </div>
              {profileData.phone && (
                <div className="footer-contact-item">
                  <Phone size={16} />
                  <a href={`tel:${profileData.phone}`}>{profileData.phone}</a>
                </div>
              )}
              <div className="footer-contact-item">
                <MapPin size={16} />
                <span>{profileData.location}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {startYear}-{currentYear} {profileData.companyName}. All rights reserved.
          </p>
          <div className="footer-legal">
            <a href="#privacy">Privacy Policy</a>
            <span>•</span>
            <a href="#terms">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
